import { Button, Col, Divider, Modal, ModalProps, Row, Typography } from 'antd';
import React from 'react';
import logoMin from '@/assets/images/Logo_Footer.png';
import { ContentWrapper } from '@/components/_common';
import { getUserFromLocalStorage } from '@/utils/user';
import { isAppPortocar } from '@/index';
import AppCopyright from '@/components/_common/AppCopyright';

type Props = Omit<ModalProps, 'onCancel'> & {
  onCancel: () => void;
};

const AboutThePlatformModal: React.FC<Props> = ({ open, onCancel }) => {
  const { matrixId } = getUserFromLocalStorage();
  return (
    <Modal
      title={'Sobre a plataforma'}
      open={open}
      onCancel={onCancel}
      width={600}
      okButtonProps={{ hidden: true }}
      cancelText="Fechar"
    >
      <Row gutter={[24, 24]}>
        <Col span={24}>
          <div style={{ width: '100%' }}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-start',
              }}
            >
              <img
                className="image"
                src={
                  isAppPortocar ? '/images/Logo_PortoCar_preto.svg' : logoMin
                }
                alt="logo"
                style={{ width: '250px' }}
              />
            </div>

            {isAppPortocar && (
              <div>
                <strong>Desenvolvido pela Ultracar</strong>
              </div>
            )}

            <div
              style={{
                marginBottom: '10px',
                display: 'flex',
                justifyContent: 'flex-start',
              }}
            >
              <Button
                type="link"
                onClick={() => window.open('http://ultracar.com.br', '_blank')}
              >
                http://ultracar.com.br
              </Button>
            </div>
          </div>
        </Col>

        <Col span={24}>
          Acessado pela nuvem, totalmente online. Com uma nova experiência,
          intuitiva, focada para uma melhor gestão de sua oficina!
        </Col>

        <Col span={24} style={{ fontWeight: 'bold' }}>
          Código do Cliente: {`${matrixId}`}
        </Col>

        <Col span={24}>
          <ContentWrapper
            style={{ padding: 16, backgroundColor: '#fafafa', borderRadius: 8 }}
          >
            <Row gutter={[8, 8]}>
              <Col span={24}>
                <Typography.Title level={5} style={{ margin: 0 }}>
                  Ultracar
                </Typography.Title>
              </Col>

              <Col span={24}>
                <Typography.Text>
                  <strong>Telefone:</strong>{' '}
                  <Typography.Link href="tel:+553132132354">
                    (31) 3213-2354
                  </Typography.Link>
                </Typography.Text>
              </Col>
            </Row>

            <Divider style={{ margin: '12px 0' }} />

            <div style={{ textAlign: 'center' }}>
              <AppCopyright />
            </div>
          </ContentWrapper>
        </Col>
      </Row>
    </Modal>
  );
};

export default AboutThePlatformModal;
